import { render, staticRenderFns } from "./CustomFormElementList.vue?vue&type=template&id=85a3c932&scoped=true"
import script from "./CustomFormElementList.vue?vue&type=script&lang=js"
export * from "./CustomFormElementList.vue?vue&type=script&lang=js"
import style0 from "./CustomFormElementList.vue?vue&type=style&index=0&id=85a3c932&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a3c932",
  null
  
)

export default component.exports